import { Box, Button, Checkbox, Flex, Progress, Text } from '@chakra-ui/react';
import { ConditionalComponent } from '@components/functionComponent';
import { usePopUpStore } from '@pages/UploadSellout/components/uploadPopUp/state';
import FieldError from '@components/fieldError';
import SpannedText from '@pages/UploadSellout/components/spannedText';
import React from 'react';

export default function FooterSection({ handleSubmit, handleCancel, progress, link }) {
    const popUpStore = usePopUpStore();
    const { onChangePopUpStore, isUploading: isLoading, isTermsChecked } = popUpStore;

    return (
        <>
            <Flex
                mb="32px"
                flexDirection="column"
                alignItems="center"
                opacity={isLoading ? 0.6 : 1}
                pointerEvents={isLoading ? 'none' : 'auto'}
            >
                <Checkbox
                    borderColor="black"
                    mr="8px"
                    isChecked={isTermsChecked}
                    isDisabled={isLoading}
                    onChange={() => {
                        if (isLoading) return;
                        onChangePopUpStore({ isTermsChecked: !isTermsChecked });
                    }}
                >
                    <Text>
                        Saya setuju dengan <SpannedText url={link}>syarat dan ketentuan</SpannedText>
                        yang berlaku.
                    </Text>
                </Checkbox>
                <FieldError message={popUpStore?.error?.isTermsChecked} mt="8px" />
            </Flex>

            <ConditionalComponent
                statement={isLoading}
                fallback={
                    <Flex justifyContent="center">
                        <Button disabled={isLoading} onClick={handleSubmit}>
                            Cek & Upload
                        </Button>
                    </Flex>
                }
            >
                <Box textAlign={'center'}>
                    <Button onClick={handleCancel} variant={'outline'} w={'150px'} mb={'24px'}>
                        Batalkan
                    </Button>
                    <Progress value={progress} size="sm" mb="12px" isAnimated />
                    <Flex justifyContent="space-between">
                        <Text>Sedang memeriksa data sell out ...</Text>
                        <Text fontWeight={700}>{progress}%</Text>
                    </Flex>
                </Box>
            </ConditionalComponent>
        </>
    );
}
